import React from 'react';
import '../../styles/HomeMembership.css';

function MembershipHome() {
  const plans = [
    {
      id: 1,
      title: "Annual Premiere",
      img: "/vscimages/membership/AnnualPremiere.jpg",
      desc: "Enjoy year-round access to Victoria Sports Club’s Fitness Gym and Water Activities, including Sauna, Jacuzzi, and Steam Room. Basketball, Tennis, and Badminton courts available with court fees.",
      featured: true
    },
    {
      id: 2,
      title: "Semi-Annual Premiere",
      img: "/vscimages/membership/02 Semi Annual.jpg",
      desc: "Enjoy 6-month access to Victoria Sports Club’s Fitness Gym and Water Activities, including Sauna, Jacuzzi, and Steam Room. Basketball, Tennis, and Badminton courts available with court fees.",
      featured: false
    },
    {
      id: 3,
      title: "Gym Access",
      img: "/vscimages/membership/Gym.jpg",
      desc: "Secure one (1) month of full access to Victoria Sports Club Gym.",
      featured: false
    }
  ];

  return (
    <section id="home-membership" className="membership-section">
      <div  className="membership-header">
        <h2>MEMBERSHIP</h2>
        <p className="sub-tagline">Get fit, get healthy, get strong</p>
        <p className="main-tagline">Join Victoria Sports Club and create a plan that fits your active lifestyle.</p>
      </div>

      <div className="membership-grid">
        {plans.map((plan) => (
          <div key={plan.id} className={`membership-card ${plan.featured ? 'featured' : 'standard'}`}>
            <div className="card-image-container">
              <img src={plan.img} alt={plan.title} />
              <div className="plan-badge">
                {plan.title}
              </div>
            </div>
            <div className="card-content">
              <p>{plan.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default MembershipHome;